import React, { useState, useEffect } from "react";
import "./SalesDetalizationModal.css";

import { API_URL, GET_TRANSACTIONS_MODAL, GET_PURCHASES } from "../../../constants";
import { OBJECT_EMPTY, GET_TOKEN } from "../../../helpers";

/**
 *
 *   Expecting ID. (props.rowid)
 *   Will use ID to fetch from DB.
 *   After receiving info, changing hook to loaded and display Data Fetched
 *
 */

export const SalesDetalizationModal = (props) => {
  const [salesDetails, setSalesDetails] = useState({});

  useEffect(() => {
    if (OBJECT_EMPTY(salesDetails)) {
      fetch(API_URL + (props.isPurchases ? GET_PURCHASES + '/' : GET_TRANSACTIONS_MODAL) + props.rowid, {
        method: "get",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
      })
        .then((response) => response.json())
        .then((response) => setSalesDetails(response));
    }
  });

  const renderItem = (item, title, img) => {
    return (
      <div className="modal-item">
        <span className="title">{title}</span>

        <div className="flex-align-center">
          {img && <img src={img} className="flag-icon-img" alt={title}/>}
          {item ? item : "No Data"}
        </div>
      </div>
    );
  };

  document.querySelector("body").addEventListener("click", function (event) {
    if (!event.target.classList.contains("SalesDetalization__settings")) {
      props.toggleModal(null);
    }
  });

  return (
    <div className={'SalesDetalizationModal__modal ' + (props.rowLevel ? 'fromBottom ' : '') + (OBJECT_EMPTY(salesDetails) ? 'hide' : 'fade-up')}>
      {OBJECT_EMPTY(salesDetails) ? (
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      ) : (
        <div className="content-wrapper">
          <div className="top-row">
            <div className="api">API {props.apiid}</div>
            <div className="date">{salesDetails["date"]}</div>
          </div>

          <div className="left-col">
            {props.isPurchases 
              ? (
                <>
                  <div>
                    {renderItem(salesDetails["order_id"], "Invoice no.")}
                    {renderItem(salesDetails["invoice_type"], "Invoice type")}
                    {renderItem(
                      salesDetails["seller_region"],
                      "Seller region"
                    )}
                    {renderItem(salesDetails["date_time"], "Date")}
                  </div>

                  <div>
                    {renderItem(salesDetails["currency"], "Currency")}
                    {renderItem(salesDetails["vat_type"], "VAT type")}
                    {renderItem(salesDetails["net_value"], "NET Value")}
                    {renderItem(salesDetails["gross_value"], "Gross Value")}
                  </div>

                  <div>
                    {renderItem(salesDetails["vat_value"], "VAT Value")}
                    {renderItem(salesDetails["vat"], "VAT %")}
                    {renderItem(salesDetails["rc"], "RC")}
                    {renderItem(salesDetails["product_type"], "Product type")}

                  </div>
                </>
              )
              : (
                <>
                  <div>
                    {renderItem(salesDetails["client_country"], "Billing Country", salesDetails["client_country_img"])}
                    {renderItem(salesDetails["ip"], "IP Address")}
                    {renderItem(salesDetails["buyer_name"], "Buyer name")}
                    {renderItem(
                      salesDetails["dispatch_country"],
                      "Country of dispatch"
                    )}
                    {renderItem(salesDetails["buyer_bank"], "Buyer Bank name")}
                  </div>

                  <div>
                    {renderItem(salesDetails["billing_adress"], "Billing address")}
                    {renderItem(salesDetails["region_by_ip"], "Region by IP", salesDetails["region_by_ip_img"])}
                    {renderItem(salesDetails["zip"], "ZIP (Postal code)")}
                    {renderItem(salesDetails["buyer_phone"], "Buyer phone")}
                    {renderItem(salesDetails["bank_country"], "Country of the bank")}
                  </div>
                </>
              )
            }


          </div>

          {salesDetails.regionchange ? (
            <div className="right-col">
              <div className="title flex-align-center">
                <span className="block icon_rotate-left"></span>
                Detected region change log
              </div>

              {salesDetails.regionchange.map((item, index) => {
                return (
                  <div className="region-item" key={index}>
                    <div className="top">
               
                      <div className="country flex-align-center">
                        {item['from_country'].img && <img src={item['from_country'].img} className="flag-icon-img" alt={item['from_country'].name}/>} 
                        {item['from_country'].name ? item['from_country'].name : "Not detected"}
                      </div>
                      <div className="icon"></div>
                      <div className="country flex-align-center">
                        {item['to_country'].img && <img src={item['to_country'].img} className="flag-icon-img" alt={item['to_country'].name}/>}
                        {item['to_country'].name ? item['to_country'].name : "Not detected"}
                      </div>
                    </div>

                    <div className="bottom">
                      {item.date ? item.date : ""}
                      {item.user_name ? " (" + item.user_name + ")" : ""} 
                    </div>
                  </div>
                );
              })}
            </div>
          ) : undefined}
        </div>
      )}
    </div>
  );
};
